import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { Plus, FileText, Edit, Trash2 } from 'lucide-react';

export default function TemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/templates').then(res => setTemplates(res.data)).finally(() => setLoading(false));
  }, []);

  const deleteTemplate = async (id) => {
    if (!window.confirm('למחוק תבנית זו?')) return;
    await api.delete(`/templates/${id}`);
    setTemplates(templates.filter(t => t.id !== id));
  };

  if (loading) return <div>טוען...</div>;

  return (
    <div>
      <div className="page-header" style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
        <div>
          <h1>תבניות PDF</h1>
          <p>העלה ונהל תבניות אישורים</p>
        </div>
        <Link to="/templates/new" className="btn btn-primary">
          <Plus size={18} /> תבנית חדשה
        </Link>
      </div>

      {templates.length === 0 ? (
        <div className="card" style={{textAlign:'center', padding:'60px 20px'}}>
          <FileText size={48} color="var(--border)" style={{margin:'0 auto 16px'}} />
          <h3 style={{marginBottom:8}}>אין תבניות עדיין</h3>
          <p style={{color:'var(--text-muted)', marginBottom:20}}>העלה את הבלנק הראשון שלך</p>
          <Link to="/templates/new" className="btn btn-primary">
            <Plus size={16} /> צור תבנית
          </Link>
        </div>
      ) : (
        <div className="grid-3">
          {templates.map(t => (
            <div key={t.id} className="card">
              <div style={{display:'flex', alignItems:'start', justifyContent:'space-between', marginBottom:12}}>
                <div style={{width:44, height:44, background:'var(--primary-light)', borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center'}}>
                  <FileText size={22} color="var(--primary)" />
                </div>
                <div style={{display:'flex', gap:8}}>
                  <Link to={`/templates/${t.id}`} className="btn btn-secondary" style={{padding:'6px 10px'}}>
                    <Edit size={14} />
                  </Link>
                  <button className="btn btn-secondary" onClick={() => deleteTemplate(t.id)} style={{padding:'6px 10px', color:'var(--danger)'}}>
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
              <h3 style={{fontSize:15, fontWeight:600, marginBottom:4}}>{t.name}</h3>
              <p style={{fontSize:12, color:'var(--text-muted)'}}>
                {t.fields?.length || 0} שדות · {new Date(t.created_at).toLocaleDateString('he-IL')}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
